(() => {
  const HANDLE = 'automatic-stainless-steel-pet-water-fountain-ultra-quiet-multi-filter';
  if (!location.pathname.includes(`/products/${HANDLE}`)) return;

  const messages = {
    'Basic payment set': 'Complete basic fountain configuration plus the additional replacement-filter pack shown in the product image.',
    'Basic payment': 'Complete basic fountain configuration with US power adapter and installed filter components shown in the product image.',
    'Filter cotton set': 'Replacement filters only — water fountain not included.',
    'Induction style set': 'Complete induction fountain configuration with the separate proximity sensor and additional replacement-filter pack shown in the product image.',
    'Induction style': 'Complete induction fountain configuration with the separate proximity sensor shown in the product image.'
  };

  function styleFieldset(root) {
    const input = root.querySelector('input[data-option-name="style"], input[name^="style-"]');
    return input?.closest('fieldset') || null;
  }

  function update(root) {
    const fieldset = styleFieldset(root);
    if (!fieldset) return;
    let note = root.querySelector('[data-pc-fountain-variant-note]');
    if (!note) {
      note = document.createElement('div');
      note.className = 'pc-fountain-variant-note';
      note.dataset.pcFountainVariantNote = '';
      note.setAttribute('role', 'status');
      note.setAttribute('aria-live', 'polite');
      fieldset.insertAdjacentElement('afterend', note);
    }
    const selected = fieldset.querySelector('input:checked')?.value || '';
    const nextMessage = messages[selected] || '';
    if (note.textContent !== nextMessage) note.textContent = nextMessage;
    note.hidden = !note.textContent;
  }

  function init() {
    document.querySelectorAll('product-info').forEach((root) => {
      if (root.dataset.pcFountainVariantNoteReady === 'true') return;
      const fieldset = styleFieldset(root);
      if (!fieldset) return;
      root.dataset.pcFountainVariantNoteReady = 'true';
      root.addEventListener('change', (event) => {
        if (event.target.matches('input[data-option-name="style"], input[name^="style-"]')) update(root);
      });
      let scheduled = false;
      const observer = new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          update(root);
        });
      });
      observer.observe(root, { childList: true, subtree: true });
      update(root);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
  init();
})();
